import { api } from "@/lib/api";

function browserDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function downloadApiFile(path, filename, mimeType, chooseFolder = false) {
  let directory = null;
  if (chooseFolder && "showDirectoryPicker" in window) {
    try {
      directory = await window.showDirectoryPicker({ mode: "readwrite", startIn: "downloads" });
    } catch (error) {
      if (error?.name === "AbortError") return { cancelled: true };
    }
  }
  const { data } = await api.get(path, { responseType: "blob" });
  const blob = new Blob([data], { type: mimeType });
  if (directory) {
    try {
      const handle = await directory.getFileHandle(filename, { create: true });
      const writable = await handle.createWritable();
      await writable.write(blob);
      await writable.close();
      return { method: "folder" };
    } catch {
      browserDownload(blob, filename);
      return { method: "browser" };
    }
  }
  browserDownload(blob, filename);
  return { method: "browser" };
}

export function safeFilename(value) {
  return value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}